<template>
  <v-row align="center" justify="center">
    <v-col class="shrink padding0">
      <div class="d-flex">
        <div>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                dark
                small
                class="mx-2"
                :color="btnNumPadColor"
                :outlined="!dialIsShowNumPads"
                @click="toggleDialPad"
              >
                <v-icon dark> mdi-apps </v-icon>
              </v-btn>
            </template>
            <span>Keypad</span>
          </v-tooltip>
        </div>
        <div>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                dark
                small
                class="mx-2"
                :color="btnMicrophoneColor"
                :outlined="!dialIsOnMute"
                @click="onClickMicrophone"
              >
                <v-icon dark>
                  {{ !dialIsOnMute ? 'mdi-microphone' : 'mdi-microphone-off' }}
                </v-icon>
              </v-btn>
            </template>
            <span>Mute</span>
          </v-tooltip>
        </div>
        <!--<div>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                dark
                small
                class="mx-2"
                :color="btnHoldColor"
                :outlined="!dialIsOnHold"
                @click="onClickHold"
              >
                <v-icon dark> mdi-pause </v-icon>
              </v-btn>
            </template>
            <span>Hold</span>
          </v-tooltip>
        </div>-->
        <div class="d-flex align-center">
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn
                  v-on="on"
                  fab
                  dark
                  small
                  class="mx-2"
                  :color="btnSpeaker.color"
                  :outlined="btnSpeaker.isOutline"
                  @click="toggleDisplayVolumeSlider"
                >
                  <v-icon dark> {{ btnSpeaker.icon }} </v-icon>
                </v-btn>
              </template>
              <span>Volume</span>
            </v-tooltip>
          </div>
          <div v-if="volume.display" class="div-slider">
            <v-slider
              v-model="volume.current"
              @change="hideVolumeSlider"
              :min="volume.min"
              :max="volume.max"
              :step="volume.step"
              vertical
              hide-details
            ></v-slider>
          </div>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import variables from '@/styles/variables.scss'

export default {
  name: 'CallingControl',
  props: {
    dialSession: Object
  },
  data() {
    return {
      btnNumPadColor: variables.textColor,
      btnMicrophoneColor: variables.textColor,
      btnHoldColor: variables.textColor,
      btnSpeaker: {
        isOutline: false,
        icon: 'mdi-volume-high',
        color: variables.textColor
      },
      volume: {
        display: false,
        current: 1,
        min: 0,
        max: 1,
        step: 0.1
      }
    }
  },
  computed: {
    ...mapGetters('call', [
      'dialIsShowNumPads',
      'dialIsOnMute',
      'dialIsOnHold',
      'dialVolume'
    ])
  },
  watch: {
    dialIsShowNumPads: {
      immediate: true,
      handler(val) {
        if (val) {
          this.btnNumPadColor = variables.primary
        } else {
          this.btnNumPadColor = variables.textColor
        }
      }
    },
    dialIsOnMute: {
      immediate: true,
      handler(val) {
        if (val) this.btnMicrophoneColor = variables.primary
        else this.btnMicrophoneColor = variables.textColor
      }
    },
    dialIsOnHold: {
      immediate: true,
      handler(val) {
        if (val) this.btnHoldColor = variables.primary
        else this.btnHoldColor = variables.textColor
      }
    },
    dialVolume: {
      immediate: true,
      handler(val) {
        this.volume.current = val
        this.btnSpeakerStyle(val)
      }
    },
    'volume.current': {
      immediate: true,
      handler(val) {
        this.changeVolume(val)
        this.btnSpeakerStyle(val)
      }
    }
  },
  methods: {
    ...mapActions('call', [
      'toggleDialPad',
      'setDialIsOnMute',
      'setDialIsOnHold',
      'setDialVolume'
    ]),
    onClickMicrophone() {
      if (this.dialIsOnMute) {
        // this.btnMicrophoneColor = variables.textColor
        this.setDialIsOnMute(false)
        this.unmute()
      } else {
        // this.btnMicrophoneColor = variables.primary
        this.setDialIsOnMute(true)
        this.mute()
      }
    },
    onClickHold() {
      if (this.dialIsOnHold) {
        this.btnHoldColor = variables.textColor
        this.setDialIsOnHold(false)
        this.unhold()
      } else {
        this.btnHoldColor = variables.primary
        this.setDialIsOnHold(true)
        this.hold()
      }
    },
    mute() {
      const session = this.dialSession
      session.mute({ audio: true })
    },
    unmute() {
      const session = this.dialSession
      session.unmute({ audio: true })
    },
    // hold() {
    //   const session = this.dialSession
    //   session.hold()
    // },
    // unhold() {
    //   const session = this.dialSession
    //   session.unhold()
    // },
    changeVolume(vol) {
      const audio = document.getElementById('audio-volume')
      audio.volume = vol
      this.setDialVolume(vol)
    },
    toggleDisplayVolumeSlider() {
      this.volume.display = !this.volume.display
    },
    hideVolumeSlider() {
      this.volume.display = false
    },
    btnSpeakerStyle(vol) {
      if (vol <= 0) {
        this.btnSpeaker.isOutline = false
        this.btnSpeaker.color = variables.primary
        this.btnSpeaker.icon = 'mdi-volume-mute'
      } else {
        this.btnSpeaker.isOutline = true
        this.btnSpeaker.color = variables.textColor
        if (vol >= 0.8) this.btnSpeaker.icon = 'mdi-volume-high'
        else if (vol >= 0.2) this.btnSpeaker.icon = 'mdi-volume-medium'
        else this.btnSpeaker.icon = 'mdi-volume-low'
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-slider--vertical {
  height: 70px;
  min-height: 70px;
}
.div-slider {
  display: block;
  position: absolute;
  right: 40px;
}
</style>
